import { FC } from 'react';

import { CoOwner, Encumbrance } from 'types';

import ShareEncumbranceViewTableHeader from './components/ShareEncumbranceViewTableHeader';
import ShareEncumbranceViewTableBody from './components/ShareEncumbranceViewTableBody';

type Props = {
  encumbrances: Encumbrance[];
  isEditing: boolean;
  isReadOnly?: boolean;
  mainCoOwner: CoOwner;
  // eslint-disable-next-line no-unused-vars
  handleEditEncumbrance: (index: number) => void;
  // eslint-disable-next-line no-unused-vars
  handleRemoveEncumbrance: (index: number) => void;
};

const ShareEncumbranceTable: FC<Props> = ({
  encumbrances,
  isEditing,
  isReadOnly,
  mainCoOwner,
  handleEditEncumbrance,
  handleRemoveEncumbrance,
}) => (
  <div className="card card-bordered pt-0 pb-0">
    <table className="table">
      <ShareEncumbranceViewTableHeader isReadOnly={isReadOnly} />
      <ShareEncumbranceViewTableBody
        encumbrances={encumbrances}
        isEditing={isEditing}
        isReadOnly={isReadOnly}
        mainCoOwner={mainCoOwner}
        handleEditEncumbrance={handleEditEncumbrance}
        handleRemoveEncumbrance={handleRemoveEncumbrance}
      />
    </table>
  </div>
);

export default ShareEncumbranceTable;
